<template>
    <div :class="className">
        <slot name="before"></slot>
        <slot name="content" :icon="stateIcon" :label="stateLabel" :error="error">
            <div class="fit d-flex flex-column justify-content-center align-items-centern bg-white-trasparent">
                <div
                        class="pt-8 pl-8 bg-contain"
                        :style="'background-image: url('+stateIcon+')'"
                ></div>
                <template v-if="stateLabel">
                    <div class="text-gray-dark text-center mw-100 p-3 pb-0">
                        {{ stateLabel }}
                    </div>
                </template>
                <template v-if="error">
                    <div class="h6 text-danger text-center mw-100 p-3 pb-0">
                        {{ error }}
                    </div>
                </template>
            </div>
        </slot>
        <slot name="afterContent"></slot>
        <slot name="beforeFile"></slot>
        <slot name="file" :fileClassName="fileClassName" :name="name" :accept="accept" :onSelectFile="onSelectFile">
            <input
                    type="file"
                    :class="fileClassName"
                    :name="!+disableFileToSend ? name : false"
                    :accept="accept"
                    ref="file"
                    @change.prevent="onSelectFile"
            >
        </slot>
        <slot name="after"></slot>
    </div>
</template>

<script>
    import mixinFile from './mixinFile'

    export default {
        name: 'InputFile',
        mixins: [ mixinFile ],
        props: {
            className: {
                type: String,
                default: 'position-relative border py-10'
            },
            fileClassName: {
                type: String,
                default: 'fit cursor-pointer w-100 h-100 opacity-0'
            },
            icon: {
                type: String,
                default: ''
            },
            iconLoaded: {
                type: String,
                default: ''
            },
            labelLoaded: {
                type: String,
                default: ''
            },

            error: {
                type: String,
                default: ''
            },

            onFileChange: {
                type: Function,
                default: () => {}
            }
        },
        computed: {
            stateLabel() {
                if( this.blob ) {
                    return this.blob.name || this.file.name || this.labelLoaded || this.label;
                }

                return this.label;
            },
            stateIcon() {
                if( !this.iconLoaded ) {
                    return this.icon;
                }
                return this.blob ? this.iconLoaded : this.icon;
            }
        },

        mounted() {},
        methods: {
            onSelectFile( evt ) {
                this.file = !!+this.multiple ? evt.target.files : evt.target.files[0];
                this.onFileChange( evt );
            }
        }
    }
</script>
